import * as React from 'react';
import * as A11yDialog from 'a11y-dialog';

import GalleryItemComponent from './gallery-item'
import ModalContentComponent from './modal-content';
import { IMediaGalleryItem } from '../../classes/media-gallery';
import { MediaGalleryAppState } from '../../classes/index';
import { connect, Dispatch } from 'react-redux';
import { getMedia } from '../redux/actions/media-api';
import { ModalState } from '../../classes/modal';
import { lockBody, unlockBody } from '../../../Static/javascript/modules/lock-body';
import { findDOMNode } from 'react-dom';
import { closeModal } from '../redux/actions/modal';

interface StateToProps {
    modalState: ModalState;
    media: IMediaGalleryItem;
}

interface DispatchToProps {
    closeModal: () => any;
}

type ModalListingProps = StateToProps & DispatchToProps;

class ModalComponent extends React.Component<ModalListingProps, null> {
    private dialog;

    constructor(props: ModalListingProps) {
        super(props);
    }

    componentDidMount() {
        const element = findDOMNode(this);

        this.dialog = new A11yDialog(element);
    }

    componentWillReceiveProps(props: ModalListingProps) {
        /*
         * The modal show / hide needs to be in this because there is nothing in render function that will trigger a change.
         */
        switch (props.modalState) {
            case ModalState.OPENED: {
                this.dialog.show();
                lockBody();
                break;
            }

            case ModalState.CLOSED: {
                this.dialog.hide();
                unlockBody();
                break;
            }

            default:
                break;
        }
    }

    closeModal() {
        this.props.closeModal();
    }

    private boundCloseModal = this.closeModal.bind(this);

    render() {
        return (
            <div id="media-gallery-modal" aria-hidden="true" className="modal-js modal-wrapper modal-multimedia">
                <div role="dialog" aria-labelledby="modalTitle" className="modal-container">
                    <div className="modal-inner" role="document">
                        <div className="modal-overlay" tabIndex={-1} onClick={this.boundCloseModal}></div>
                        <button type="button" onClick={this.boundCloseModal} aria-label="Close this dialog window" className="modal-close"></button>

                        <ModalContentComponent />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: MediaGalleryAppState): StateToProps {
    return {
        modalState: state.modalModel.modalState,
        media: state.modalModel.content
    }
}

function mapDispatchToProps(dispatch: Dispatch<MediaGalleryAppState>): DispatchToProps {
    return {
        closeModal: () => dispatch(closeModal())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ModalComponent);


// WEBPACK FOOTER //
// ./app/media-gallery/components/modal.tsx